import { createSlice } from "@reduxjs/toolkit";
import { sendOtp, verifyOtp, updateProfile, fetchMe } from "./authThunk";

const token = localStorage.getItem("token");

const initialState = {
  isAuthenticated: !!token,
  user: {
    name: "",
    mobile: "",
    address: {
      line1: "",
      city: "",
      pincode: "",
    },
    avatar: "",
  },
  token,
  status: "idle",
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,

  reducers: {
    logout: (state) => {
      state.user = initialState.user;
      state.token = null;
      state.isAuthenticated = false;
      state.status = "idle";
      state.error = null;

      localStorage.removeItem("token");
    },
  },

  extraReducers: (builder) => {
    builder
      // -------- SEND OTP --------
      .addCase(sendOtp.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(sendOtp.fulfilled, (state) => {
        state.status = "success";
      })
      .addCase(sendOtp.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      })

      // -------- VERIFY OTP --------
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.user = action.payload.user;
        state.token = action.payload.token;
        state.isAuthenticated = true;
        state.status = "success";

        localStorage.setItem("token", action.payload.token);
      })

      // -------- UPDATE PROFILE --------
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.user = {
          ...state.user,
          ...action.payload,
        };
        state.status = "success";
      })

      // -------- FETCH ME (BOOTSTRAP) --------
      .addCase(fetchMe.fulfilled, (state, action) => {
        state.user = action.payload;
        state.isAuthenticated = true;
        state.status = "success";
      })
      .addCase(fetchMe.rejected, (state) => {
        // token invalid / expired
        state.user = initialState.user;
        state.token = null;
        state.isAuthenticated = false;
        localStorage.removeItem("token");
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
